import { AppRoutes, User, UserType } from './props'

const getStoredAuthToken = (): string => {
  const storedToken = localStorage.getItem('token');
  if (!storedToken) {
    return '';
  }

  try {
    const parsedToken = JSON.parse(storedToken);
    return typeof parsedToken === 'string' ? parsedToken : '';
  } catch {
    return storedToken.replace(/['"]+/g, '');
  }
};

export const buildAuthenticatedFileUrl = (fileUrlOrName: string): string => {
  const value = (fileUrlOrName || '').trim();
  if (!value) {
    return '';
  }

  const authToken = getStoredAuthToken();
  if (!authToken) {
    return value;
  }

  const apiBase = (process.env.REACT_APP_API_BASE_URL || '').trim().replace(/\/$/, '');

  try {
    if (/^https?:\/\//i.test(value)) {
      const absoluteUrl = new URL(value);
      absoluteUrl.searchParams.set('auth_token', authToken);
      return absoluteUrl.toString();
    }

    if (value.startsWith('/')) {
      if (!apiBase) {
        return value;
      }

      const relativeUrl = new URL(value, `${apiBase}/`);
      relativeUrl.searchParams.set('auth_token', authToken);
      return relativeUrl.toString();
    }

    if (!apiBase) {
      return value;
    }

    const encodedFilename = encodeURIComponent(value);
    return `${apiBase}/files/${encodedFilename}?auth_token=${encodeURIComponent(authToken)}`;
  } catch {
    return value;
  }
};

export const isAuthPage = () => {
  const location = window.location.href;
  return (
    location.toLocaleLowerCase().includes(AppRoutes.Login) ||
    location.toLocaleLowerCase().includes(AppRoutes.Register) ||
    location.toLocaleLowerCase().includes(AppRoutes.ForgotPassword) ||
    location.toLocaleLowerCase().includes(AppRoutes.ChangePassword) ||
    location.toLocaleLowerCase().includes(AppRoutes.FileApproval) ||
    location.toLocaleLowerCase().includes(AppRoutes.FileEdit)
  );
};

export const handleLogout = (navigate: (path: string) => void) => {
  localStorage.clear()

  navigate(AppRoutes.Login);
};

export const isAuth = (user: User) => {
  return !!user;
};

export const isAdmin = () => {
  return localStorage.getItem('type') === UserType.Admin.toString();
}

export const isRegularUser = () => {
  return localStorage.getItem('type') === UserType.Regular.toString();
}

export const isUserPage = () => {
  const location = window.location.href;
  return location.toLocaleLowerCase().includes('/user-information') ||
         location.toLocaleLowerCase().includes('/user-documents');
}